import { INLINE_TEXT_SELECTORS } from "./Selectors";
import IToolConfig from "../types/IToolConfig";

export interface IFilters {
    [key: string]: IToolConfig
}

export const FILTERS: IFilters = {
    'dark-contrast': {
        styles: {
            'color': '#FFF',
            'fill': '#FFF',
            'background-color': '#181818'
        },
        // Every element gets the dark backdrop: any tag left out of a list
        // (Divi puts excerpt text bare inside <article> over a white <div>)
        // keeps its original light background under forced-white text.
        childrenSelector: [''],
        // Inline text elements would paint that backdrop over the previous
        // line's glyphs wherever line-height < the font's content box.
        backgroundResetSelectors: INLINE_TEXT_SELECTORS as string[],
    },
    'light-contrast': {
        styles: {
            'color': '#000',
            'fill': '#000',
            'background-color': '#FFF'
        },
        // Same universal-backdrop + inline-reset treatment as dark-contrast:
        // the inline overlap clips wrapped headings identically (white boxes
        // over black glyphs), and dark-themed sites need every container
        // whitened for the forced-black text to stay readable.
        childrenSelector: [''],
        backgroundResetSelectors: INLINE_TEXT_SELECTORS as string[],
    },
    // Colour filters run once, on <html>. A `filter` on any other element
    // makes it the containing block for its absolute/fixed descendants and a
    // stacking context, and nested filters compound (ALLY-169). The widget's
    // own UI is filtered along with the page — there is no way to exempt a
    // descendant of the root.
    'high-contrast': {
        styles: {
            'filter': 'contrast(125%)'
        },
        applyToRoot: true
    },
    'high-saturation': {
        styles: {
            'filter': 'saturate(200%)'
        },
        applyToRoot: true
    },
    'low-saturation': {
        styles: {
            'filter': 'saturate(50%)'
        },
        applyToRoot: true
    },
    'monochrome': {
        styles: {
            'filter': 'grayscale(100%)'
        },
        applyToRoot: true
    }
}

export default FILTERS